// application/authorizationChange.js

/**
 * The vocabulary three parties share: the unit of work produces changes, `commitAuthorizations`
 * routes them, and an AuthorizationRepository applies them. It lives on its own so the repository
 * adapter need not import a concrete application service to read an enum it was handed.
 *
 * `update` REWRITES THE RECORD IN PLACE, terms included — a deliberate trade taken with product. A
 * correction leaves nothing behind: the figures a past service was entitled to are replaced with no
 * record that they moved. What buys it is that nothing consumes an authorization yet.
 *
 * IT STOPS BEING FREE THE DAY CONSUMPTION EXISTS. Extensions and re-authorizations arrive as version
 * documents in this collection, and this verb then narrows to correcting the live version.
 *
 * @typedef {'create' | 'update' | 'delete'} AuthorizationIntent
 *
 * @typedef {Object} AuthorizationChange
 * @property {AuthorizationIntent} intent
 * @property {import('../domain/model/Authorization.types').Authorization} authorization
 */

/** @type {Record<string, AuthorizationIntent>} */
// eslint-disable-next-line import/prefer-default-export
export const AUTHORIZATION_INTENT = {
  CREATE: 'create',
  UPDATE: 'update',
  DELETE: 'delete',
};
